import { useAuth } from '../contexts/AuthContext';

/** آیا صفحهٔ وابسته به سازمان فعال باید مسدود شود؟ */
export function useTenantGuard() {
  const { requiresActiveOrganization: needsTenant, activeOrganization } = useAuth();
  const blocked = needsTenant && !activeOrganization?.id;
  return { blocked, needsTenant, activeOrganization };
}
